import React from 'react';
import ContentLayout from '../../../components/ContentLayout';
import Tabs from '../../../components/Tabs';
import props from '../../../lib/contentLayoutProps/admissions/layoutProps';

const tabs = ['Playgroup', 'Children Centre and Kindergarten', 'Primary School'];

/* eslint-disable react/prop-types */
export default class extends React.Component {
  state = {
    tab: 0,
  };

  render() {
    const { tab } = this.state;

    return (
      <ContentLayout {...props} locale="en" pageKey="entry-requirements">
        <h1>Entry Requirements</h1>
        <Tabs tabs={tabs} onChangeTab={index => this.setState({ tab: index })} />
        {tab === 0 && (
          <React.Fragment>
            <p>
              Acceptance will be determined by the availability of space. All students must have gained approval from
              the Hong Kong Immigration Department to enter/ remain in Hong Kong.
            </p>
            <p>
              Since our term commences mid-August, students must be one year old, by the end of December of the year
              they enter school.
            </p>

            <h3>Admission To Kingston Primary School</h3>
            <p>
              Children who attend Kingston International Kindergarten have priority for admission to Year One at
              Kingston International School over students who have not attended Kingston International Kindergarten.
              First priority for entry to Kingston International School goes to those Kindergarten students who have
              attended Kingston since Playgroup.
            </p>

            <h3>Playgroup School Hours</h3>
            <table>
              <tbody>
                <tr>
                  <td>AM session classes</td>
                  <td>8:45 a.m. - 11:00 a.m.</td>
                </tr>
                <tr>
                  <td>PM session classes</td>
                  <td>1:30 p.m. - 03:45 p.m.</td>
                </tr>
              </tbody>
            </table>

            <h3>Teacher/Student Ratio</h3>
            <table>
              <tbody>
                <tr>
                  <td>Playgroup</td>
                  <td>2:16</td>
                </tr>
              </tbody>
            </table>
          </React.Fragment>
        )}
        {tab === 1 && (
          <React.Fragment>
            <p>
              Acceptance will be determined by the availability of space. All students must have gained approval from
              the Hong Kong Immigration Department to enter/ remain in Hong Kong.
            </p>
            <p>
              Since our term commences mid-August, students must be of the appropriate age, by the end of December of
              the year they enter school.
            </p>

            <table>
              <thead>
                <tr>
                  <th>Class</th>
                  <th>Age as of December 31st</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>2 Year Old Class</td>
                  <td>Two years old</td>
                </tr>
                <tr>
                  <td>3 Year Old Class</td>
                  <td>Three years old</td>
                </tr>
                <tr>
                  <td>4 Year Old Class</td>
                  <td>Four years old</td>
                </tr>
              </tbody>
            </table>

            <h3>Admission To Kingston Primary School</h3>
            <p>
              Children who attend Kingston International Kindergarten have priority for admission to Year One at
              Kingston International School over students who have not attended Kingston International Kindergarten.
              First priority for entry to Kingston International School goes to those Kindergarten students who have
              attended Kingston since Playgroup.
            </p>

            <h3>School Hours</h3>
            <table>
              <tbody>
                <tr>
                  <td>AM session classes</td>
                  <td>8:45 a.m. - 11:45 a.m.</td>
                </tr>
                <tr>
                  <td>PM session classes</td>
                  <td>1:30 p.m. - 04:30 p.m.</td>
                </tr>
              </tbody>
            </table>

            <h3>Teacher/Student Ratio</h3>
            <table>
              <tbody>
                <tr>
                  <td>2 Year Old Class</td>
                  <td>2:16</td>
                </tr>
                <tr>
                  <td>3 Year Old Class</td>
                  <td>2:18</td>
                </tr>
                <tr>
                  <td>4 Year Old Class</td>
                  <td>2:20</td>
                </tr>
                <tr>
                  <td>5 Year Old Class</td>
                  <td>4:5</td>
                </tr>
              </tbody>
            </table>
          </React.Fragment>
        )}
        {tab === 2 && (
          <React.Fragment>
            <p>
              Students should possess a reasonable proficiency in one or both languages – English and Putonghua.
              Acceptance will be determined by the availability of space. Students must be of the appropriate age, by
              the end of December of the year they enter school.
            </p>
            <p>
              All students must have gained approval from the Hong Kong Immigration Department to enter/ remain in Hong
              Kong.
            </p>

            <table>
              <thead>
                <tr>
                  <th>Class</th>
                  <th>Age as of December 31st</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Year 1</td>
                  <td>Five years old</td>
                </tr>
                <tr>
                  <td>Year 2</td>
                  <td>Six years old</td>
                </tr>
                <tr>
                  <td>Year 3</td>
                  <td>Seven years old</td>
                </tr>
                <tr>
                  <td>Year 4</td>
                  <td>Eight years old</td>
                </tr>
                <tr>
                  <td>Year 5</td>
                  <td>Nine years old</td>
                </tr>
                <tr>
                  <td>Year 6</td>
                  <td>Ten years old</td>
                </tr>
              </tbody>
            </table>

            <h3>School Hours</h3>
            <p>
              School Hours are from 8:45 a.m. to 3:15 p.m. (Monday to Friday). Parents should supply their child with a
              healthy lunch, and two healthy snacks.
            </p>
          </React.Fragment>
        )}
      </ContentLayout>
    );
  }
}
